import React from 'react';
import { Col, Row } from 'react-bootstrap';

import camLoeppky from '../../../assets/images/camLoeppky.png';
import ReadMore from '../../components/ReadMore';

const MessageFromChairman = ({ width, isMobile }) => {
  return (
    <Col>
      <Row>
        <Col xs={12} sm={7} md={8}
          lg={9} xl={9}
        // xl={10}
        >
          <Row>
            <Col xs={isMobile ? 12 : 7} sm={12}>
              <h2
                id="message-from-the-chairman-of-the-board"
                tabIndex="-1"
                style={{ textAlign: 'left' }}
              >
                message from {width < 576 ? 'CHAIR-\nMAN' : 'CHAIRMAN'}  of the board
              </h2>
            </Col>
            {!isMobile && width < 576 && <Member />}
          </Row>

          <div className="quoteSubheader" style={{ marginTop: 30 }}>
            As CSIO reached the final year of its multi-year
            strategic roadmap, I look back on everything we’ve
            accomplished together since 2018 with a strong
            sense of pride. Milestones such as launching My
            Proof of Insurance (MPOI), forming the Commercial
            Lines (CL) Working Group and establishing the
            Innovation and Emerging Technology (INNOTECH)
            Advisory Committee have positioned us for
            sustained future success.
          </div>
          <p style={{ marginTop: 30 }}>
            Even as the P&C insurance
            industry rapidly evolves, I’m confident CSIO’s
            leading-edge technology Standards and solutions
            will continue to enhance customer experiences in
            the broker channel.
          </p>
          <ReadMore href="/message-from-chairman#top" />
        </Col>
        {!isMobile && width >= 576 && <Member />}
      </Row>
    </Col>
  )
}

export default MessageFromChairman;

const Member = () => (
  <Col xs={5} sm={5} md={4} lg={3} xl={3}
    // xl={2} 
    style={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      // paddingLeft: 60,
    }}>
    <img
      src={camLoeppky}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
        // marginTop: 60
        marginTop: 8,
        marginBottom: 25
      }}
      aria-label="picture of Cam Loeppky"
    />
    <div className="homepageExecName">
      CAM LOEPPKY
    </div>
    <div className="homepageExecTitle">
      CSIO CHAIRMAN
    </div>
    <div className="homepageExecDetail" style={{ paddingLeft: 8, paddingRight: 8 }}>
    The Wawanesa Mutual <br />Insurance Company<br />Senior Vice President &<br/> Chief Information Officer
    </div>
  </Col>
);
